export class Utente {

	constructor(
		public codiceFiscale: string, public nome: string, public cognome: string,
		public dataDiNascita: string, public email: string, public pec: string,
		public denominazione: string, public partitaIVA: string, public idPersonaFisica: string) { }

	public hasPartitaIva(): boolean {
		return this.partitaIVA != null && this.partitaIVA.length == 11;
	}
}